import type { ReactNode } from 'react';

// tipos disponíveis: tag-muted, tag-danger, tag-warning, tag-success, tag-info (ver design-system.css)
export function Tag({
  type = 'muted',
  icon,
  // Uma etiqueta curta às vezes precisa explicar o que resume — "já veio" não
  // diz de quantos eventos. `title` é o tooltip nativo: sem dependência, e o
  // leitor de tela também lê.
  title,
  children,
}: {
  type?: string;
  icon?: string;
  title?: string;
  children: ReactNode;
}) {
  return (
    <span className={`tag tag-${type}`} title={title}>
      {icon && <i className={`ti ${icon}`} style={{ fontSize: 10 }} />}
      {children}
    </span>
  );
}
